import { BusinessLocationMarker, BusinessNameLocationMarker } from '@/components/Business'
import { MapView } from '@/components/MapView'
import { useLocations } from '@/queries/locations/useLocations'
import { usePlaceDetails } from '@/queries/locations/usePlaceDetails'
import { useStytchOrganization } from '@stytch/react/b2b'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import type { FC } from 'react'
import type { ViewState } from 'react-map-gl/mapbox'

export const LocationMap: FC = () => {
	const { placeId } = useParams()
	const { organization } = useStytchOrganization()
	const { data: locations = [] } = useLocations({ workspaceId: organization?.organization_id })
	const { data: placeResult } = usePlaceDetails(placeId ?? '')

	const DEFAULT_LATITUDE = 39.8283
	const DEFAULT_LONGITUDE = -98.5795

	const [viewState, setViewState] = useState<ViewState>({
		latitude: Number(locations?.at(0)?.latitude ?? DEFAULT_LATITUDE),
		longitude: Number(locations?.at(0)?.longitude ?? DEFAULT_LONGITUDE),
		zoom: 3.5,
		pitch: 15,
		bearing: 0,
		padding: { top: 170, bottom: 0, left: 0, right: 0 },
	})

	useEffect(() => {
		if (placeResult) {
			setViewState({
				latitude: Number(placeResult.geometry?.location?.lat ?? DEFAULT_LATITUDE),
				longitude: Number(placeResult.geometry?.location?.lng ?? DEFAULT_LONGITUDE),
				zoom: 9,
				pitch: 15,
				bearing: 0,
				padding: { top: 170, bottom: 0, left: 0, right: 0 },
			})
		}
	}, [placeResult])

	return (
		<MapView viewState={viewState} onMapMoved={(evt) => setViewState(evt.viewState)}>
			{placeResult && (
				<BusinessLocationMarker
					key={placeResult.place_id}
					latitude={Number(placeResult.geometry?.location?.lat ?? DEFAULT_LATITUDE)}
					longitude={Number(placeResult.geometry?.location?.lng ?? DEFAULT_LONGITUDE)}
					location={placeResult}
				/>
			)}
			{/* Show existing locations with just a name marker */}
			{locations
				?.filter((location) => location.id !== Number(placeResult?.place_id))
				.map((location) => {
					const latitude = Number(location?.latitude ?? DEFAULT_LATITUDE)
					const longitude = Number(location?.longitude ?? DEFAULT_LONGITUDE)

					return (
						<BusinessNameLocationMarker
							key={location.id}
							latitude={latitude}
							longitude={longitude}
							name={`${location.name}`}
						/>
					)
				})}
		</MapView>
	)
}
